/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Group_YearInputs */

const vi_report_group_year = /** @type {(inputs: Report_Group_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Năm`)
};

/**

* @param {Report_Group_YearInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_group_year = /** @type {((inputs?: Report_Group_YearInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Group_YearInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_group_year(inputs)
});